module.exports = __webpack_public_path__ + "static/heading-ddfaf40e7c2c476f363f89c5a132affb.png";